import { render, staticRenderFns } from "./BaseEnvironmentWizard.vue?vue&type=template&id=27e96520&"
import script from "./BaseEnvironmentWizard.vue?vue&type=script&lang=ts&"
export * from "./BaseEnvironmentWizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports